export const emptyScreenContent = {
    'dari': {
        "There are no master distributors added yet": `تاکنون توزیع‌کننده ارشد (ماستر) اضافه نشده‌ است`,
        "Click “Add Master Distributor” to create one": `برای ایجاد توزیع‌کننده ارشد روی  کلید"اضافه کردن ماستر" کلیک نمایید`,
        "There are no distributors added yet": "شماره جواز کسب‌وکار را وارد کنید",
        "Click “Add Distributor” to create one": "تاریخ آغاز اعتبار",
        "There are no sub distributors added yet": "مخابرات",
        "Click “Add Sub Distributor” to create one": "درصد هزینه خدمات افزودن پول به حساب  به صورت الکترونیکی",
    },
    'pashto': {
        "There are no master distributors added yet": "تر اوسه پورې، د لوړ پوړو توزیع کونکو نه دی اضافه شوی",
        "Click “Add Master Distributor” to create one": `د ماسټر توزیع کونکي رامینځته کولو لپاره "ماسټر اضافه کړئ" تڼۍ کلیک وکړئ`,
        "There are no distributors added yet": "د کاروبار د جواز شمېره د ننه کړئ",
        "Click “Add Distributor” to create one": "د اعتبار د پیل نټېه",
        "There are no sub distributors added yet": "مخابرات",
        "Click “Add Sub Distributor” to create one": "په الکترونیکي (برېښنايي) ډول د پیسو اضافه کولو  د لګښت سلنه",
    },
    'uzbeki': {
        "There are no master distributors added yet": "هنوزگچه هیچ بیر اساسی توزیع قیلوچی قوشیلمه‌گن",
        "Click “Add Master Distributor” to create one": `اونی یره‌تیش «اساسی توزیع قیلوچینی قوشیش اوچون» توکمه‌نی باسینگ`,
        "There are no distributors added yet": "تجارت لایسنس نمبرینی کیریتینگ",
        "Click “Add Distributor” to create one": "تجارت عمل قیله‌دی",
        "There are no sub distributors added yet": "تیلیکام",
        "Click “Add Sub Distributor” to create one": "تۉلدیریش خدمتی تولاوی فایزی E Top Up",
    }

};